var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructThreeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 294,
    viewBox: "0 0 424 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.180866 13.8643C-0.964236 6.58297 4.66436 0 12.0352 0H390.622C396.53 0 401.559 4.29978 402.476 10.1357L423.707 145.136C423.902 146.371 423.902 147.629 423.707 148.864L402.476 283.864C401.559 289.7 396.53 294 390.622 294H12.0352C4.66435 294 -0.964237 287.417 0.180864 280.136L20.8254 148.864C21.0196 147.629 21.0196 146.371 20.8254 145.136L0.180866 13.8643Z",
    fill: "#E8EEF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructThreeBg);
export default __webpack_public_path__ + "static/media/instructThreeBg.d47581f076102bceed76ee12acfc6634.svg";
export { ForwardRef as ReactComponent };